import React from "react";
import Form, { InputSection } from "../../components/Form";
import { Field, Formik } from "formik";
import { DropDown, DropDownOptionsProps } from "../../../../ui/DropDown";
import Input from "../../../../ui/Input";
import { TitleText } from "../../../../ui/Text";
import styled from "styled-components";
import { IndicatorIcon } from "../../../../assets/svg/IndicatorIcon";
import {
  parseDropdown,
  parseKPIOptions,
} from "../../../../utils/parseDropdown";
import { get } from "../../../../utils/get";

interface IProps {
  kpiOptions?: any;
  values?: any;
}

const AlignmentOptions = ({ kpiOptions, values }: IProps) => {
  const alignments = [
    {
      label: "Link",
      value: "link",
    },
    // {
    //   label: "Rollup Sum",
    //   value: "summation",
    // },
    // {
    //   label: "Rollup Average",
    //   value: "aggregation",
    // },
  ];
  const selectedKpi = kpiOptions.filter(
    (kpi) => kpi.id === get(values, "supported_kpi.value")
  );
  const Validate = (value) => {
    let error;

    if (!value) {
      error = "Value required";
    }

    return error;
  };
  return (
    <Form>
      <Field
        name="alignment"
        placeholder="select.."
        dropdownLabel="Alignment"
        validate={Validate}
        component={DropDown}
        width="15em"
        options={alignments}
        isBordered={true}
      />
      <Field
        name="supported_kpi"
        placeholder="select kpi name"
        dropdownLabel="Supported KPI"
        validate={Validate}
        component={DropDown}
        width="20em"
        options={parseKPIOptions(kpiOptions)}
        isBordered={true}
        value={get(values, "supported_kpi")}
      />
      <InputSection>
        <TitleText>Supporting KPIs</TitleText>
      </InputSection>
      <InputSection>
        <SupportingKpis>
          <TitleText style={{ color: "#CDD4E2" }}>KPI Name</TitleText>
          {get(selectedKpi[0], "child_kpis") &&
            get(selectedKpi[0], "child_kpis").map((child) => {
              return (
                <>
                  <Indicator>
                    <span>
                      <IndicatorIcon color="green" />
                    </span>
                    <TitleText>{child.name}</TitleText>
                  </Indicator>
                </>
              );
            })}
        </SupportingKpis>
      </InputSection>
    </Form>
  );
};

export default AlignmentOptions;

const SupportingKpis = styled.div`
  display: grid;
`;

const Indicator = styled.span`
  background-color: #f5f6fb;
  color: #444;
  cursor: pointer;
  padding: 0.75em;
  display: flex;
  align-items: center;
  border: none;
  border-radius: 1em;
  margin-bottom: 0.5em;
  margin-right: 0.75em;
  outline: none;
  transition: background-color 0.6s ease;

  span {
    margin-right: 1em;
  }
`;
